import React, { useContext } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { AuthenticationContext } from '../Auth/authentication.context'

const StatusAccessControl = () => {
  const { status } = useContext(AuthenticationContext)
  const location = useLocation()
  const statusAccessMap = {
    0: ['/pharmacy/profile'],   
    1: ['/pharmacy/profile'],  //!added
    2: ['/pharmacy/profile', '/pharmacy/manufacturers'],  
    3: ['/pharmacy/profile', '/pharmacy/manufacturers'],  
    4: ['/pharmacy/profile', '/pharmacy/manufacturers', '/pharmacy/add-orders', '/pharmacy/orders', '/pharmacy/orders/:orderId', '/pharmacy/recommendations'],
    5: ['/pharmacy/profile', '/pharmacy/manufacturers', '/pharmacy/add-orders', '/pharmacy/orders', '/pharmacy/orders/:orderId', '/pharmacy/recommendations']
  };

  const allowedRoutes = statusAccessMap[status] || []

  // A single path segment standing in for a `:param` placeholder.
  const PARAM_SEGMENT = /^[\w-]+$/

  const isAllowed = (route) => {
    // Matches exact routes hash map
    if (route === location.pathname) return true

    // Checks dynamic routes such as /pharmacy/orders/:orderId. Compared segment
    // by segment rather than by building a RegExp out of the route string: the
    // pattern is fixed, so nothing from the route can alter how matching works.
    const routeSegments = route.split('/')
    const pathSegments = location.pathname.split('/')

    if (routeSegments.length !== pathSegments.length) return false

    return routeSegments.every((segment, i) =>
      segment.startsWith(':')
        ? PARAM_SEGMENT.test(pathSegments[i])
        : segment === pathSegments[i]
    )
  }

  const routeAllowed = allowedRoutes.some(isAllowed)

  if (!routeAllowed) {
    return <Navigate to='/403' />
  }

  return <Outlet />
}

export default StatusAccessControl
